var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 65,
    viewBox: "0 0 27 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4273_23542)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.07217,
    y: 5.35952,
    width: 24.4068,
    height: 57.7189,
    rx: 7.50345,
    fill: "white",
    stroke: "#B4B4B4",
    strokeWidth: 2.14384
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4273_23542",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.07031,
    width: 8.24555,
    height: 5.77189,
    rx: 1.64911
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9.07031,
    width: 8.24555,
    height: 5.77189,
    rx: 1.64911,
    fill: "#B4B4B4",
    stroke: "#B4B4B4",
    strokeWidth: 4.28769,
    mask: "url(#path-2-inside-1_4273_23542)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.1438,
    y: 10.5537,
    width: 22.263,
    height: 51.4523,
    rx: 5.60698,
    fill: "#FF0082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.14406 25.6268C2.14406 25.6268 2.65993 23.2854 4.84979 22.8054C7.03965 22.3255 8.83846 26.3252 12.3579 25.0453C15.8773 23.7654 15.7991 19.1257 16.894 17.6858C17.989 16.2459 19.7095 14.966 21.5084 15.286C23.3072 15.6059 24.4705 16.8341 24.382 15.286C24.2935 13.7379 23.9211 11.6963 23.9211 11.6963L20.9835 8.50684L3.44201 9.12639C3.44201 9.12639 2.62804 9.89713 2.14406 15.286C1.66008 20.6748 2.14406 25.6268 2.14406 25.6268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4273_23542)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4043 46.8368C9.60608 46.9451 9.85626 46.887 9.99011 46.7024L17.2999 36.621C17.4007 36.482 17.415 36.2982 17.337 36.1452C17.259 35.9922 17.1017 35.8959 16.93 35.8959H14.993L17.3225 31.9876C17.4066 31.8464 17.4084 31.671 17.3272 31.528C17.2461 31.3851 17.0944 31.2969 16.93 31.2969H11.4477C11.2379 31.2969 11.0551 31.4398 11.0044 31.6434L9.17693 38.9836C9.14297 39.12 9.17373 39.2645 9.26029 39.3753C9.34688 39.4861 9.47965 39.5508 9.62024 39.5508H11.7031L9.19228 46.2744C9.1123 46.4885 9.20288 46.7288 9.40429 46.8368L9.4043 46.8368ZM12.7895 39.2536C12.8419 39.1134 12.8222 38.9563 12.7369 38.8333C12.6515 38.7103 12.5113 38.6369 12.3615 38.6369H10.2049L11.8049 32.2104H16.126L13.7966 36.1187C13.7124 36.2599 13.7106 36.4354 13.7918 36.5783C13.873 36.7212 14.0247 36.8094 14.189 36.8094H16.0346L11.2253 43.4422L12.7895 39.2536Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4273_23542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.5507,
    height: 64.1504,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4273_23542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.22357,
    height: 15.5942,
    fill: "white",
    transform: "translate(9.16357 31.2964)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.3a7cdac05fddaf9c1e3e5b88574a3e3a.svg";
export { ForwardRef as ReactComponent };